import Typography from '@mui/material/Typography';
import {
  Dropdown,
  TextField,
  TextFieldSize,
} from '@packages/shared-ui/v4/form';
import { useState } from 'react';
import { stateAbbreviations } from '@/constants/solarEcomm/form';
import useStyles from './CheckoutFormFields.styles';

const FIELD_SIZE = { xs: TextFieldSize.Small, md: TextFieldSize.Large };

interface FieldConfig {
  name: string;
  label: string;
  autoComplete: string;
  type?: string;
  inputMode?: 'tel' | 'email' | 'numeric';
}

const NAME_FIELDS: FieldConfig[] = [
  { name: 'firstName', label: 'First name', autoComplete: 'given-name' },
  { name: 'lastName', label: 'Last name', autoComplete: 'family-name' },
];

const CONTACT_FIELDS: FieldConfig[] = [
  {
    name: 'phone',
    label: 'Phone',
    autoComplete: 'tel',
    type: 'tel',
    inputMode: 'tel',
  },
  {
    name: 'email',
    label: 'Email',
    autoComplete: 'email',
    type: 'email',
    inputMode: 'email',
  },
];

function Field({ label, ...field }: FieldConfig) {
  return (
    <TextField label={label} fullWidth inputSize={FIELD_SIZE} {...field} />
  );
}

export default function CheckoutFormFields() {
  const { classes, cx } = useStyles();
  const [state, setState] = useState('');

  return (
    <section className={classes.section}>
      <Typography variant='h3' component='h2'>
        Your information
      </Typography>
      <div className={cx(classes.row, classes.twoColumns)}>
        {NAME_FIELDS.map((field) => (
          <Field key={field.name} {...field} />
        ))}
      </div>
      <Field name='address' label='Address' autoComplete='street-address' />
      <div className={cx(classes.row, classes.threeColumns)}>
        <Field name='city' label='City' autoComplete='address-level2' />
        <Dropdown
          name='state'
          className={classes.stateDropdown}
          label='State'
          options={stateAbbreviations}
          value={state}
          onChange={setState}
          fullWidth
          inputSize={FIELD_SIZE}
        />
        <Field
          name='zip'
          label='Zip code'
          autoComplete='postal-code'
          inputMode='numeric'
        />
      </div>
      <div className={cx(classes.row, classes.twoColumns)}>
        {CONTACT_FIELDS.map((field) => (
          <Field key={field.name} {...field} />
        ))}
      </div>
    </section>
  );
}
